import { Component, DoCheck, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterModule, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonService } from '../_service/common.service';

@Component({
    selector: 'app-suppliertab',
    templateUrl: './suppliertab.component.html',
    styleUrls: ['./suppliertab.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        RouterModule,
        MatIconModule
    ]
})
export class SuppliertabComponent implements OnInit, DoCheck {

  public roleVariableHide = false;

  public roleVariableHide2 = false;

  public showBuyerProfile : any = false;
  public envHide : any = "";
  public superUserShow : any= false;
  public prodHide = false;
  public showCpyBatchToSuper : any = false;
  public showForConsult = false;
  showForSupplier: boolean;

  cmpActiveTab = "tab-a";
  GrpActiveTab = "tab-a";
  SitActiveTab = "tab-a";
  ConActiveTab = "tab-a";
  WkfActiveTab = "tab-a";
  OrbisActiveTab="tab-a";
  AdminActiveTab="tab-a";
  public roleIsManager =false;

  constructor(private commonService: CommonService,private router: Router) { }

  ngOnInit() {
    if(this.router.url=="/company"){
      this.cmpActiveTab = "active";
    } else if(this.router.url=="/supplier-group"){
      this.GrpActiveTab = "active";
    } else if(this.router.url=="/sites"){
      this.SitActiveTab = "active";
    } else if(this.router.url=="/contacts"){
      this.ConActiveTab = "active";
    } else if(this.router.url=="/workflow"){
      this.WkfActiveTab = "active";
    }else if(this.router.url=="/orbis"){
      this.OrbisActiveTab = "active";
    }else if(this.router.url=="/administration"){
      this.AdminActiveTab = "active";
    }
  } 

  ngDoCheck() { 
    this.getRoles();
  }

  getRoles() {
    let RoleByService = this.commonService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);
  }

  checkAllProfilesAndEnv(RoleByService){

    let c = RoleByService;
    //console.info("checkAllProfilesAndEnv Cmp",c);
    if(c['buyer'] == 'yes'){
      this.showBuyerProfile = false;
    }else{
      this.showBuyerProfile = true;
    }
    if(c['env'] =='qua' || c['env'] == 're7' || c['env'] == 'ope'){
      this.envHide = false;
    }else{
      this.envHide = true;
    }
    if(c['role'] !=undefined){
    if(c['role'] == 'admin' || c['role'].includes('admin') || c['role'] == 'buyer' || c['role'].includes('buyer') || c['role'] == 'manager' || c['role'].includes('manager')){
      this.roleVariableHide = true;
    }else{
      this.roleVariableHide = false;
    }
  
    if(c['superAdmin'] == 'yes'){
      this.superUserShow = true;
    }else{
      this.superUserShow = false;
    }
    if(c['env'] == 'ope'){
      this.prodHide = true;
    }else {
      this.prodHide = false;
    }if(c['role'] == 'manager'){
      this.roleIsManager = true;
    }else{
      this.roleIsManager = false;
    }

    
    if(c['role'] == 'admin' || c['role'].includes('admin')){
      this.roleVariableHide2 = true;
    }else{
      this.roleVariableHide2 = false;
    }

    if(c['superAdminAllProfiles'] == 'yes'){
      this.showCpyBatchToSuper = true;
    }else{
      this.showCpyBatchToSuper = false;
    }
    if(c['role'] == 'consult' || c['role'].includes('consult')){
      this.showForConsult = false;
    }else{
      this.showForConsult = true;
    }
    if(c['role'] == 'supplier'){
      this.showForSupplier = false;
    }else{
      this.showForSupplier = true;
    }
  }
  }

}
